import { z } from 'zod';

import { FullPageContent } from '@/components/layout/full-page-content';
import { SlideOver } from '@/components/ui/slide-over';
import { UserRole } from '@/entities/user-role';
import { codec, useQueryParams } from '@/hooks/router/use-query-params';
import { useCurrentAsset } from '@/hooks/use-current-asset';
import { useMe } from '@/hooks/use-me';
import { ListTasks } from '@/task-manager/api/queries/list-tasks';
import { TaskBoardActions } from '@/task-manager/components/task-board-actions';
import { TasksFilters } from '@/task-manager/components/tasks-filters';

import { TaskDetailsPage } from '../tasks';

import { TasksBoard } from './tasks-board';

export function AssetTasks() {
  const currentAsset = useCurrentAsset();
  const me = useMe();
  const [{ id }, queryParams] = useQueryParams({
    id: {
      key: 'id',
      schema: z.string().optional(),
      codec: codec.string,
    },
  });
  const [filters, setFilters] =
    ListTasks.useGetFiltersFromQueryParams(currentAsset);

  const frontendId =
    currentAsset.asset?.fullFrontendId ?? currentAsset.vehicle?.fullFrontendId;
  if (!currentAsset.assetId || !frontendId) {
    return null;
  }

  function openDetails(id: string) {
    queryParams.replace({ id });
  }

  function closeDetails() {
    queryParams.replace({ id: undefined });
  }

  return (
    <>
      <FullPageContent
        className="relative grid grid-rows-[min-content_1fr]"
        testId="tasks-page"
      >
        <div className="flex w-full flex-row items-end justify-between gap-4 border-b p-4">
          <TasksFilters
            filters={filters}
            onChange={(filters) => setFilters.push(filters)}
          />
          {me.role !== UserRole.THIRD_PARTY ? <TaskBoardActions /> : null}
        </div>
        <TasksBoard
          filters={filters}
          asset={{ id: currentAsset.assetId, frontendId }}
          onTaskOpen={openDetails}
        />
      </FullPageContent>
      <SlideOver open={Boolean(id)} onClose={closeDetails}>
        {id ? <TaskDetailsPage id={id} onClose={closeDetails} /> : null}
      </SlideOver>
    </>
  );
}
